import { AiFillHome } from "react-icons/ai";
import { BsWalletFill } from "react-icons/bs";
import { BiTransfer, BiHistory } from "react-icons/bi";
import { FaUsers } from "react-icons/fa";
import { MdCandlestickChart } from "react-icons/md";

const userDashLinks = [
  {
    url: "/user/dashboard",
    name: "Dashboard",
    icon: (
      <AiFillHome className="cursor-pointer text-[16px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1] " />
    ),
  },
  {
    url: "/user/deposit",
    name: "Deposit",
    icon: (
      <BsWalletFill className="cursor-pointer text-[16px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1] " />
    ),
  },
  {
    url: "/user/trade",
    name: "Trade",
    icon: (
      <MdCandlestickChart className="cursor-pointer text-[17px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1]" />
    ),
  },
  {
    url: "/user/transfer",
    name: "Transfer",
    icon: (
      <BiTransfer className="cursor-pointer text-[16px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1] " />
    ),
  },
  {
    url: "/user/kyc",
    name: "KYC",
    icon: (
      <FaUsers className="cursor-pointer text-[16px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1]" />
    ),
  },
  {
    url: "/user/transactions",
    name: "Transactions",
    icon: (
      <BiHistory className="cursor-pointer text-[16px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1] " />
    ),
  },
];

export default userDashLinks;
